import script from "./StallItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./StallItem.vue?vue&type=script&setup=true&lang=ts"

import "./StallItem.vue?vue&type=style&index=0&id=03f99464&scoped=true&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03f99464"]])

export default __exports__